export default __webpack_public_path__ + "static/blakes-logo-f79f0cd1920f70df1b0b186d60988c6f.png";